import React, { useState } from "react";
import { TouchableOpacity, View } from "react-native";

import { Text, Modal, GridView, Button } from "components";
import { colors, sizes, strings } from "assets/constants";
import { sn } from "utils";
import css from "styles";
import tinycolor from "tinycolor2";
import { useChangeCustomersGroup } from "clients/apis";

const ChangeGroupModal: React.FC<{
  extraData: { categories: any };
  onConfirm?: (groupId: number) => void;
  onCancel?: () => void;
}> = (props) => {
  const { extraData, onCancel, onConfirm } = props;

  const [selectedGroupId, setSelectedGroupId] = useState(null);

  const _onConfirm = () => {
    onConfirm(selectedGroupId);
  };

  return (
    <Modal visible={true} hideCloseBtn>
      <>
        <View style={{ marginBottom: 25 }}>
          <Text weight="bold" size={"xxl"}>
            {strings.changing_customer_group}
          </Text>
        </View>
        <GridView
          spacing={sizes.space / 2}
          gridHeight={70}
          numberOfCol={sn(3, 3, 4, 5)}
          data={extraData?.categories?.data?.data}
          renderItem={(item: any) => {
            const active = selectedGroupId === item?.id;

            const _onSelect = () => setSelectedGroupId(item?.id);

            return (
              <TouchableOpacity
                style={css.cover}
                onPress={_onSelect}
                activeOpacity={sizes.tapOpacity}
              >
                <View
                  style={{
                    width: "100%",
                    height: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: sizes.radius.lg,
                    backgroundColor: active
                      ? tinycolor(colors.theme).lighten(50).toString()
                      : colors.white,
                    paddingHorizontal: 5,
                    borderWidth: 1,
                    borderColor: active
                      ? tinycolor(colors.theme).lighten(40).toString()
                      : tinycolor(colors.text.normal).lighten(64).toString(),
                  }}
                >
                  <Text
                    weight={active ? "bold" : "default"}
                    color={active ? colors.theme : colors.text.normal}
                    align="center"
                  >
                    {item?.title}
                  </Text>
                </View>
              </TouchableOpacity>
            );
          }}
        />
      </>
      <View
        style={{
          ...css.paddingH,
          ...css.rowCenterAlign,
          marginBottom: sizes.space,
        }}
      >
        <Button
          onPress={_onConfirm}
          title={{ value: strings.confirm }}
          width={100}
          bgColor={colors.success}
          style={{ marginRight: sizes.space }}
        />

        <Button
          onPress={onCancel}
          title={{ value: strings.cancel }}
          outline
          width={100}
          bgColor={colors.danger}
        />
      </View>
    </Modal>
  );
};

export default ChangeGroupModal;
